import { Helmet } from "react-helmet-async";
import { business } from "../config/business";

const ServiceSchema = ({ serviceType, description }) => {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "Service",
    serviceType,
    provider: { "@type": "Organization", name: business.name, "@id": `${business.siteUrl}/#organization` },
    areaServed: [
      { "@type": "State", name: "Telangana" },
      { "@type": "State", name: "Andhra Pradesh" },
    ],
    description,
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
    </Helmet>
  );
};

export default ServiceSchema;
